export const APIError = {
    internalServerError: {
        code: 'INTERNAL_SERVER_ERROR',
        statusCode: 500,
        message: 'Something went wrong.',
    },

    loginFailed: {
        code: 'LOGIN_FAILED',
        statusCode: 400,
        message: 'Email or password does not match.',
    },

    deletedAccount: {
        code: 'DELETED_ACCOUNT',
        statusCode: 400,
        message: 'Account is deleted.',
    },

    invalidParameter: {
        code: 'INVALID_PARAMETER',
        statusCode: 400,
        message: 'One or more parameters are invalid',
    },

    emailAlreadyInUse: {
        code: 'EMAIL_ALREADY_IN_USE',
        statusCode: 400,
        message: 'The provided email address is already in use.',
    },

    accessDenied: {
        code: 'ACCESS_DENIED',
        statusCode: 403,
        message: 'You do not have permission to perform this task.',
    },

    inactiveUser: {
        code: 'INACTIVE_USER',
        statusCode: 401,
        message: 'Your account is inactive.',
    },

    invalidAccessToken: {
        code: 'INVALID_ACCESS_TOKEN',
        statusCode: 401,
        message: 'The provided access token is invalid.',
    },

    expiredAccessToken: {
        code: 'EXPIRED_ACCESS_TOKEN',
        statusCode: 401,
        message: 'The provided access token expired.',
    },

    expiredPasswordRecoveryToken: {
        code: 'EXPIRED_PASSWORD_RECOVERY_TOKEN',
        statusCode: 401,
        message: 'The provided password recovery token expired.',
    },

    invalidPasswordRecoveryToken: {
        code: 'INVALID_PASSWORD_RECOVERY_TOKEN',
        statusCode: 401,
        message: 'The provided password recovery token is invalid.',
    },

    invalidRefreshToken: {
        code: 'INVALID_REFRESH_TOKEN',
        statusCode: 401,
        message:
            'The provided refresh token is invalid, please try signing in again.',
    },
    invalidPassword: {
        code: 'INVALID_PASSWORD',
        statusCode: 400,
        message: 'Old password was invalid',
    },

    invalidVerificationCode: {
        code: 'INVALID_VERIFICATION_CODE',
        statusCode: 400,
        message: 'The provided verification code is invalid.',
    },

    signUpCodeExpired: {
        code: 'SIGN_UP_CODE_EXPIRED',
        statusCode: 400,
        message: 'Invite link has expired.',
    },

    userAlreadyAcceptedInvite: {
        code: 'USER_ALREADY_ACCEPTED_INVITE',
        statusCode: 400,
        message: 'User has already accepted the invite.',
    },

    notFound: {
        code: 'NOT_FOUND',
        statusCode: 404,
        message: 'Resource not found.',
    },

    requestBatchingNotAllowed: {
        code: 'REQUEST_BATCHING_NOT_ALLOWED',
        statusCode: 400,
        message: 'Request batching is not allowed for this call.',
    },

    shortPassword: {
        code: 'SHORT_PASSWORD',
        statusCode: 400,
        message: 'Your password must be at least 8 letters.',
    },

    confirmPasswordFailed: {
        code: 'CONFIRM_PASSWORD_FAILED',
        statusCode: 400,
        message: 'Password and Confirm Password do not match.',
    },

    deleteIsNotAllowed: {
        code: 'DELETE_IS_NOT_ALLOWED',
        statusCode: 400,
        message: 'You can not delete this record.',
    },
    clientDataMismatch: {
        code: 'CLIENT_DATA_MISMATCH_ERROR',
        statusCode: 400,
        message: 'Client data does not match the server data.',
    },
    isNotEligibleForInvite: {
        code: 'IS_NOT_ELIGIBLE_FOR_INVITE',
        statusCode: 400,
        message: 'User is not eligible to be invited.',
    },
    quizAlreadyCompleted: {
        code: 'QUIZ_ALREADY_COMPLETED',
        statusCode: 400,
        message:
            'This quiz has already been completed. Answers cannot be modified after completion.',
    },
    badRequest: {
        code: 'BAD_REQUEST',
        statusCode: 400,
        message: 'Bad request.',
    },
};
